import * as types from './showActionTypes';

export const getShowInformation = () => ({
    type: types.GET_SHOW_REQUEST
});



// WEBPACK FOOTER //
// ./src/store/show/showActions.js